import React from 'react';
import { Flex, Text, Select, Spacer } from '@chakra-ui/react';

const JobOpeningSortBar = ({ totalJobs = 0 }) => (
  <Flex align="center" mb={4}>
    <Text fontSize="sm" color="gray.600">All <b>{totalJobs}</b> jobs found</Text>
    <Spacer />
    <Text fontSize="sm" color="gray.600" mr={2}>Short:</Text>
    <Select size="sm" w="120px" defaultValue="latest">
      <option value="latest">Latest</option>
      <option value="oldest">Oldest</option>
      <option value="salary_high">Salary: High to Low</option>
      <option value="salary_low">Salary: Low to High</option>
    </Select>
  </Flex>
);

export default JobOpeningSortBar; 